import(/* webpackMode: "eager" */ "/home/ubuntu/IdxAutoBotNext/src/app/error.js");
